/**
 * 余额管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/payCenter/billingRecordList' }"
        >开票记录</el-breadcrumb-item
      >
      <el-breadcrumb-item>开票详情</el-breadcrumb-item>
    </el-breadcrumb>
    <!--账单列表-->
    <div class="info-block">
      <p class="info-title"><span class="title">开票明细</span></p>
      <!--默认-->
      <div class="info-body">
        <el-row :gutter="20">
          <el-col :span="8"
            ><div>
              <div class="m-bott-15">
                <span>公司名称：</span><span>{{ info.companyName }}</span>
              </div>
              <div class="m-bott-15">
                <span>税务登记号：</span><span>{{ info.taxNumber }}</span>
              </div>
              <div class="m-bott-15">
                <span>开户行帐号：</span
                ><span>{{ info.depositBankAccount }}</span>
              </div>
              <div class="m-bott-15">
                <span>开户行：</span><span>{{ info.depositBank }}</span>
              </div>
              <div class="m-bott-15">
                <span>发送至邮箱：</span><span>{{ info.sendToMail }}</span>
              </div>
            </div></el-col
          >
          <el-col :span="8"
            ><div>
              <div class="m-bott-15">
                <span>地址：</span><span>{{ info.address }}</span>
              </div>
              <div class="m-bott-15">
                <span>电话：</span><span>{{ info.phone }}</span>
              </div>
              <div class="m-bott-15">
                <span>发票类型：</span><span>{{ info.invoiceType }}</span>
              </div>
              <div class="m-bott-15">
                <span>开票类目：</span><span>{{ info.invoiceCategory }}</span>
              </div>
            </div></el-col
          >
          <el-col :span="8"
            ><div>
              <div class="m-bott-15">
                <span>开票金额：</span><span>{{ info.invoiceAmount }}</span>
              </div>
              <div class="m-bott-15">
                <span>备注：</span><span>{{ info.remark }}</span>
              </div>
              <div class="m-bott-15">
                <span>开票状态：</span><span>{{ info.recordStatus }}</span>
              </div>
              <div class="m-bott-15">
                <span>电子发票格式：</span
                ><span>{{ info.electronicInvoiceFormat }}</span>
              </div>
            </div></el-col
          >
        </el-row>
        <hr />
        <el-table
          size="small"
          :data="detail_table1"
          highlight-current-row
          v-loading="loading"
          element-loading-text="拼命加载中"
          style="width: 100%"
        >
          <!-- <el-table-column align="center" type="selection" width="60">
          </el-table-column> -->
          <el-table-column
            fixed
            prop="rechargeId"
            label="充值id"
            min-width="200"
          >
          </el-table-column>
          <el-table-column prop="arrivalTime" label="充值时间" min-width="200">
          </el-table-column>
          <el-table-column
            prop="rechargeAmount"
            label="充值金额"
            min-width="200"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.rechargeAmount.toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="invoiceAmount"
            label="开票金额"
            min-width="200"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.invoiceAmount.toFixed(2) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="voidedAmount" label="作废金额" min-width="300">
            <template slot-scope="scope">
              <span>{{ scope.row.voidedAmount.toFixed(2) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="info-block">
      <p class="info-title"><span class="title">关联任务</span></p>
      <!--默认-->
      <div class="info-body">
        <el-table
          size="small"
          :data="detail_table2"
          highlight-current-row
          v-loading="loading"
          element-loading-text="拼命加载中"
          style="width: 100%"
        >
          <!-- <el-table-column align="center" type="selection" width="60">
          </el-table-column> -->
          <el-table-column
            fixed
            prop="taskName"
            label="任务名称"
            min-width="200"
          >
          </el-table-column>
          <el-table-column prop="taskType" label="任务类型" min-width="200">
          </el-table-column>

          <el-table-column prop="" label="任务描述" min-width="300">
            <template slot-scope="scope">
              <el-popover placement="top-start" width="200" trigger="hover">
                <span>【服务内容】{{ scope.row.content }}</span
                ><br />
                <span>【计费模式】{{ scope.row.billMode }}</span
                ><br />
                <span>【服务时间】{{ scope.row.serviceTime }}</span>

                <span class="btnNoBorderBlue" slot="reference">查看</span>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="info-block">
      <p class="info-title"><span class="title">发票开具详情</span></p>
      <!--默认-->
      <div class="info-body">
        <el-table
          size="small"
          :data="detail_table3"
          highlight-current-row
          v-loading="loading"
          element-loading-text="拼命加载中"
          style="width: 100%"
        >
          <!-- <el-table-column
            fixed
            prop="invoiceCode"
            label="发票代码"
            min-width="200"
          >
          </el-table-column>
          <el-table-column
            prop="invoiceNumber"
            label="发票票号"
            min-width="200"
          >
          </el-table-column> -->
          <el-table-column prop="invoiceDate" label="开票日期">
          </el-table-column>
          <!-- <el-table-column
            prop="netAmount"
            label="开具金额(不含税)"
            min-width="200"
          >
            <template slot-scope="scope">
              <span v-if="shouldDisplayNetAmount(scope.row.netAmount)">
                {{ scope.row.netAmount.toFixed(2) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="totalAmount"
            label="价税合计(小写)"
            min-width="200"
          >
            <template slot-scope="scope">
              <span v-if="shouldDisplayNetAmount(scope.row.totalAmount)">
                {{ scope.row.totalAmount.toFixed(2) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column
            prop="totalAmountCh"
            label="价税合计(大写)"
            min-width="200"
          >
          </el-table-column> -->
          <el-table-column prop="invoiceStyle" label="发票样式">
          </el-table-column>
          <el-table-column prop="" label="发票">
            <template slot-scope="scope">
              <span
                class="btnNoBorderBlue"
                @click="opendetails(scope.row.invoiceDownloadUrl)"
                >查看</span
              >
            </template>
          </el-table-column>

          <!-- <el-table-column
            prop="invoiceStatus"
            label="发票状态"
            :cell-style="getStatusStyle"
          >
          </el-table-column> -->

          <el-table-column label="发票状态">
            <template slot-scope="scope">
              <span :style="getStatusStyle(scope.row.invoiceStatus)">
                {{ scope.row.invoiceStatus }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--充值打款信息-->
    <div class="info-block">
      <p class="info-title">
        <span class="title">物流信息</span>
      </p>
      <div class="info-body">
        <div class="el-row">
          <div class="el-col-8">
            <span>物流单号：</span><span>{{ info.trackingNumber }}</span>
          </div>
          <div class="el-col-8">
            <span>寄件时间： </span><span>{{ info.dispatchAt }}</span>
          </div>
          <div class="el-col-8">
            <span>邮寄地址：</span
            ><span
              >{{ info.mailingAddress ? info.mailingAddress.detail : "-" }}
            </span>
          </div>
        </div>

        <div class="el-row marginTop20">
          <div class="el-col-24">
            <span>当前物流状态：</span
            ><span>{{ info.deliveryStatus ? info.deliveryStatus : "" }} </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 编辑界面 -->
    <el-dialog
      :title="title"
      :visible.sync="editFormVisible"
      width="30%"
      @click="closeDialog"
    >
      <el-form
        label-width="120px"
        :model="editForm"
        :rules="rules"
        ref="editForm"
      >
        <el-form-item label="部门名称" prop="deptName">
          <el-input
            size="small"
            v-model="editForm.deptName"
            auto-complete="off"
            placeholder="请输入部门名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="部门代码" prop="deptNo">
          <el-input
            size="small"
            v-model="editForm.deptNo"
            auto-complete="off"
            placeholder="请输入部门代码"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="loading"
          class="title"
          @click="submitForm('editForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  receiptInfo,
  billsList,
  billexcel,
  invoicedetails,
} from "../../api/userMG";
import Pagination from "../../components/Pagination";
export default {
  data() {
    return {
      detail_table1: [],
      detail_table2: [],
      detail_table3: [],
      info: {},
      status_list: [
        {
          label: "加款",
          value: 1,
        },
        {
          label: "扣款",
          value: 2,
        },
        {
          label: "退款",
          value: 3,
        },
        {
          label: "退票",
          value: 4,
        },
        {
          label: "垫付资金",
          value: 5,
        },
        {
          label: "垫资还款",
          value: 6,
        },
        {
          label: "原路退款",
          value: 7,
        },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: "添加",
      editForm: {
        date: [],
        positionId: "",
        positionName: "",
        positionState: "",
      },
      // rules表单验证
      rules: {},
      formInline: {
        page: 1,
        pageSize: 10,
        varLable: "",
        varName: "",
        token: localStorage.getItem("logintoken"),
        operationType: 1,
        date: [],
        startDate: "",
        endDate: "",
      },
      balance: JSON.parse(localStorage.getItem("user_info")).balance,
      name: JSON.parse(localStorage.getItem("user_info")).createUserId,
      // 删除部门
      seletedata: {
        ids: "",
        token: localStorage.getItem("logintoken"),
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        page: 1,
        pageSize: 10,
        total: 10,
      },
    };
  },
  // 注册组件
  components: {
    Pagination,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getinvoicedetails(this.$route.query.id);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    shouldDisplayNetAmount(netAmount) {
      // 检查 netAmount 是否为 0.00、0、null 或空字符串
      return (
        netAmount !== 0 &&
        netAmount !== 0.0 &&
        netAmount !== null &&
        netAmount !== ""
      );
    },
    opendetails(url) {
      if (!url) {
        this.$message.error("发票正在生成上传中，请稍后重试");
        return;
      }
      window.open(url);
    },
    exportdata() {
      billexcel().then((res) => {
        if (res.msg == "success") {
          window.open(res.data.downloadUrl);
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    getinvoicedetails(id) {
      invoicedetails(id)
        .then((res) => {
          if (res.msg != "success") {
            this.$message({
              type: "error",
              message: res.msg,
            });
          } else {
            this.info = res.data;
            this.detail_table1 = res.data.linkedRechargeRecordsList;
            // let obj1 = {
            //   rechargeId: res.data.rechargeId,
            //   arrivalTime: res.data.arrivalTime,
            //   rechargeAmount: res.data.rechargeAmount,
            //   invoiceAmount: res.data.invoiceAmount,
            // }
            // this.detail_table1.push(obj1)

            this.detail_table2 = res.data.linkedTasksList;
            // let obj2 = {
            //   taskName: res.data.taskName,
            //   taskType: res.data.taskType,
            // }
            // this.detail_table2.push(obj2)

            this.detail_table3 = res.data.invoiceDetailList;
            // let obj3 = {
            //   invoiceCode: res.data.invoiceCode,
            //   invoiceNumber: res.data.invoiceNumber,
            //   invoiceDate: res.data.invoiceDate,
            //   netAmount: res.data.netAmount,
            //   totalAmount: res.data.totalAmount,
            //   totalAmountCh: res.data.totalAmountCh,
            //   invoiceStyle: res.data.invoiceStyle,
            //   invoiceDownloadUrl: res.data.invoiceDownloadUrl,
            //   invoiceStatus: res.data.invoiceStatus,
            // };
            // this.detail_table3.push(obj3);
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate((valid) => {
        if (valid) {
          // deptSave(this.editForm)
          //   .then(res => {
          //     this.editFormVisible = false
          //     this.loading = false
          //     if (res.success) {
          //       this.getdata(this.formInline)
          //       this.$message({
          //         type: 'success',
          //         message: '公司保存成功！'
          //       })
          //     } else {
          //       this.$message({
          //         type: 'info',
          //         message: res.msg
          //       })
          //     }
          //   })
          //   .catch(err => {
          //     this.editFormVisible = false
          //     this.loading = false
          //     this.$message.error('公司保存失败，请稍后再试！')
          //   })
        } else {
          return false;
        }
      });
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // deptDelete(row.deptId)
          //   .then(res => {
          //     if (res.success) {
          //       this.$message({
          //         type: 'success',
          //         message: '公司已删除!'
          //       })
          //       this.getdata(this.formInline)
          //     } else {
          //       this.$message({
          //         type: 'info',
          //         message: res.msg
          //       })
          //     }
          //   })
          //   .catch(err => {
          //     this.loading = false
          //     this.$message.error('公司删除失败，请稍后再试！')
          //   })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false;
    },
    getStatusStyle(status) {
      const colorMap = {
        红冲发票: "color: red; font-weight: bold",
        作废发票: "color: gray; text-decoration: line-through",
        正常发票: "color: green",
      };
      return colorMap[status] || ""; // 未知状态返回空样式
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #fff;
}
.el-form-item {
  margin-bottom: 10px !important;
}
.userRole {
  width: 100%;
}
.info-block {
  background: #fff;
  margin-top: 20px;
  box-sizing: border-box;
}
.info-block .info-title {
  font-size: 16px;
  width: 100%;
  padding: 0 32px;
  line-height: 56px;
  border-bottom: 1px solid #e5e5e5;
  box-sizing: border-box;
}

.info-block .info-body {
  padding: 24px 32px;
}
.blockTitle span:nth-child(2) {
  font-size: 18px;
  color: #272727;
  margin-top: 10px;
  font-weight: 700;
}
.blockTitleOrage span:nth-child(2) {
  color: #ff943e;
  font-weight: 700;
  font-size: 20px;
  margin-top: 10px;
}
.marginTop20 {
  margin-top: 20px;
}
.m-bott-15 {
  margin-bottom: 15px;
}
.btnNoBorderBlue {
  color: #1985ff;
  cursor: pointer;
}
</style>

 


// WEBPACK FOOTER //
// src/views/payCenter/invoiceDetail.vue